@if (showSelector) {
  @if (showNewMenu()) {
    <button mat-icon-button [matMenuTriggerFor]="appsMenu">
      <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #appsMenu>
      @for (navItem of centerData; track $index) {
        @if (navItem.centerId !== serviceProviderId) {
          <a mat-menu-item [href]="navItem.entryUrl">
            {{ navItem.name }}
          </a>
        }
      }
    </mat-menu>
  } @else {
    <atlas-item icon="apps" interactable ariaLabel="App switcher">
      <atlas-menu id="atlas-navbar__center-selector">
        <div>
          @for (navItem of centerData; track navItem) {
            @if (navItem.centerId !== serviceProviderId) {
              <atlas-menu-item
                [label]="navItem.name"
                [url]="navItem.entryUrl"
              ></atlas-menu-item>
            }
          }
        </div>
      </atlas-menu>
    </atlas-item>
  }
}
